module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "760px",
      "height": "570px"
    }
  }, [(_vm.img_detail.url.indexOf('pdf') != -1) ? _c('div', {
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "height": "100%"
    }
  }, [(_vm.img_detail.is_place && _vm.img_detail.is_place == 2) ? _c('img', {
    staticClass: "yiguidang",
    attrs: {
      "src": require("../../assets/images/zhang1.gif")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.img_detail.is_really && _vm.img_detail.is_really == 1) ? _c('img', {
    staticClass: "yiguidang",
    attrs: {
      "src": require("../../assets/images/zhang4.gif")
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.img_detail.url_list || _vm.img_detail.url_list.length == 0) ? _c('object', {
    staticStyle: {
      "border": "#ccc 1px solid"
    },
    attrs: {
      "data": _vm.img_detail.url,
      "type": "application/pdf",
      "width": "100%",
      "height": "570px"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.img_detail.url.indexOf('jpg') != -1 || _vm.img_detail.url.indexOf('jpeg') != -1 || _vm.img_detail.url.indexOf('png') != -1) ? _c('div', {
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "height": "100%"
    }
  }, [(_vm.img_detail.is_place && _vm.img_detail.is_place == 2) ? _c('img', {
    staticClass: "yiguidang",
    attrs: {
      "src": require("../../assets/images/zhang1.gif")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.img_detail.is_really && _vm.img_detail.is_really == 1) ? _c('img', {
    staticClass: "yiguidang",
    attrs: {
      "src": require("../../assets/images/zhang4.gif")
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticStyle: {
      "border": "#ccc 1px solid",
      "max-height": "100%",
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.img_detail.url
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33918c33!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/image.vue
// module id = 1826
// module chunks = 2